import { render, staticRenderFns } from "./ReportTableGroupRow.vue?vue&type=template&id=2c1fcedf&scoped=true&"
import script from "./ReportTableGroupRow.vue?vue&type=script&lang=ts&"
export * from "./ReportTableGroupRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1fcedf",
  null
  
)

export default component.exports